module.exports = __webpack_public_path__ + "img/delete.bacffd9b.svg";